// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.text_input_mode_enum */
var TextInputModeEnum;
(function (TextInputModeEnum) {
    TextInputModeEnum["free_text"] = "free_text";
    TextInputModeEnum["dropdown"] = "dropdown";
    TextInputModeEnum["autocomplete"] = "autocomplete";
})(TextInputModeEnum || (TextInputModeEnum = {}));
;
export default TextInputModeEnum;
/** Zod schema for text_input_mode_enum */
export const textInputModeEnum = z.nativeEnum(TextInputModeEnum);
//# sourceMappingURL=TextInputModeEnum.js.map